import React, { useEffect, useState } from "react";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "../ui/drawer";
import { beneCategory } from "@/constants";
import { ChevronRight } from "lucide-react";
import AddBeneficiaryModal from "../modals/add-beneficiary-modal";

const CategoryDrawer = ({
  showModal,
  setShowModal,
  editedItem,
  setRefetch,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (editedItem) {
      setShowModal(false);
      setOpen(true);
    }
  }, [editedItem]);

  return (
    <>
      <Drawer open={showModal} onOpenChange={() => setShowModal(false)}>
        <DrawerContent className="">
          <DrawerHeader>
            <DrawerTitle className="text-center text-xl">
              Select Category
            </DrawerTitle>
          </DrawerHeader>

          <div className="mx-auto w-full px-3 md:max-w-sm">
            <div className="flex flex-col gap-5 pt-3 pb-12">
              {beneCategory.map((item, index) => (
                <div
                  key={index}
                  className="flex cursor-pointer items-center justify-between"
                  onClick={() => {
                    localStorage.setItem("beneficiaryType", item.type);
                    setShowModal(false);
                    setOpen(true);
                  }}
                >
                  <div className="flex items-center gap-2">
                    <div
                      className={`flex size-14 items-center justify-center rounded-full ${item.color}`}
                    >
                      <item.icon size={27} className="text-white" />
                    </div>

                    <div className="flex flex-col">
                      <h2 className="text-lg font-medium">{item.title}</h2>

                      <p className="text-sm text-gray-400">
                        {item.description}
                      </p>
                    </div>
                  </div>

                  <ChevronRight />
                </div>
              ))}
            </div>
          </div>
        </DrawerContent>
      </Drawer>

      <AddBeneficiaryModal
        open={open}
        onClose={() => setOpen(false)}
        editItem={editedItem}
        setRefetch={setRefetch}
      />
    </>
  );
};

export default CategoryDrawer;
